export default {
    filters: {
        contraction: value => {
            if (value.length > 20) {
                return value.slice(0, 10).trim() + '...' + value.slice(-10).trim()
            }

            return value
        },
    },
    install(Vue) {
        const filters = Object.keys(this.filters)

        filters.forEach(k => Vue.filter(k, this.filters[k]))
    }
}



// WEBPACK FOOTER //
// ./src/common/filters.js